import React from 'react';
import Autocomplete from 'react-autocomplete'


const menuStyle ={
  backgroundColor:'#fff',
  padding: '2px 0',
  magin: '0px',
  position: 'absolute',
  overflow: 'auto',
  maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
  color: "#222",
  width: "auto",
  fontSize: '14px',
}


export default class SelectedCountryInput extends React.PureComponent {

  state = {
    value: null
  }

  render(){

    const { items, countries, selectCountry, selectedCountry, inputProps={}} = this.props
    const valueFromProps = selectedCountry ? countries[selectedCountry] : ''
    const value = this.state.value  === null ? valueFromProps : this.state.value

    return (

      <Autocomplete
         getItemValue={(item) => item.value}
         menuStyle={menuStyle}
         inputProps={inputProps}
         items={items.sort(i => i.label)}
         shouldItemRender={(item, value)=>{ return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 }}
         renderItem={(item, isHighlighted) =>
           <div className="pa1" style={{ background: isHighlighted ? 'lightgray' : '#fff' }}>
             {item.label}
           </div>
         }
         value={value}
         onChange={(e) => this.setState({value:e.target.value}) }
         onSelect={(val) => {
           this.setState({value:countries[val]})
           selectCountry(val)
         } }

       />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectedCountryInput/index.js